import { useMarkers } from "../../contexts/Markers";
import { useRoot } from "../../contexts/Root";
import { Bar } from "./Bar";

import styles from "./Markers.module.css";

export const Markers = () => {
  const { markers } = useMarkers();
  const {
    theme: { foreground },
  } = useRoot();

  return (
    <Bar show={markers.length > 0} zIndex={3}>
      {markers.map(({ label, offset }) => {
        const style = {
          background: foreground,
          transform: `translateX(${offset}px)`,
        };

        return (
          <div className={styles.marker} key={label + offset} style={style} />
        );
      })}
    </Bar>
  );
};
